module.exports = __webpack_public_path__ + "fonts/icomoon.ea051030.ttf";